import { useEffect, useState } from "react";

export default function Preloader() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <>
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/10 backdrop-blur-sm">
        <div className="corners relative w-10 h-10">
          <div className="corner corner--1"></div>
          <div className="corner corner--2"></div>
          <div className="corner corner--3"></div>
          <div className="corner corner--4"></div>
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .corners {
          transform-origin: center;
          animation: spin 3s infinite linear;
        }

        .corner {
          width: 100%;
          height: 100%;
          position: absolute;
        }

        .corner::before {
          content: "";
          display: block;
          width: 48%;
          height: 48%;
          background-color: #ffffff;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes spin1 {
          0% {
            transform: rotate(0deg);
          }
          30% {
            transform: rotate(0deg);
          }
          70% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes spin2 {
          0% {
            transform: rotate(0deg);
          }
          30% {
            transform: rotate(270deg);
          }
          70% {
            transform: rotate(270deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes spin3 {
          0% {
            transform: rotate(0deg);
          }
          30% {
            transform: rotate(180deg);
          }
          70% {
            transform: rotate(180deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes spin4 {
          0% {
            transform: rotate(0deg);
          }
          30% {
            transform: rotate(90deg);
          }
          70% {
            transform: rotate(90deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .corner--1 {
          animation: spin1 3s infinite cubic-bezier(0.785, 0.135, 0.15, 0.86);
        }

        .corner--2 {
          animation: spin2 3s infinite cubic-bezier(0.785, 0.135, 0.15, 0.86);
        }

        .corner--3 {
          animation: spin3 3s infinite cubic-bezier(0.785, 0.135, 0.15, 0.86);
        }

        .corner--4 {
          animation: spin4 3s infinite cubic-bezier(0.785, 0.135, 0.15, 0.86);
        }
      `}</style>
    </>
  );
}
